// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: '/auth/login',
  register: '/auth/register',
  resetPassword: '/auth/reset-password',
//   newPassword: '/auth/new-password',
  resetPasswordSent: '/auth/reset-password-sent',
  emailLink: '/auth/email-link'
};

export const PATH_DASHBOARD = {
  root: '/jobs',
};
